module.exports = __webpack_public_path__ + "static/media/stijn-bessem-clients-t-mobile.1a5570e5.svg";